export default import.meta.ROLLUP_FILE_URL_CfKAg4U5;